import React from "react";

interface DropDownProps {
  className?: string;
  childrenClassName?: string;
  styles?: { [key: string]: string };
  readonly: boolean;
  children?: React.ReactNode;
}

export const Dropdowns = ({ className, styles, readonly, children }: DropDownProps) => {
  return (
    <div className={`${className ?? ""}${readonly ? " disabled" : ""}`} style={{ ...styles }} aria-disabled={readonly}>
      {children}
    </div>
  );
};

export default Dropdowns;
